module.exports = __webpack_public_path__ + "media/images/error-0a6ac4d1.svg";